import React, { useEffect, useState } from "react"
import { PageContainer, PageWrapper, sharedConfigurationSelectors, TEnv, useSelector } from "swiipe.portal.shared"
import PageTitle from "../../components/page/PageTitle"
import useReduxDispatch from "../../store/useReduxDispatch"
import "./TranslationsPage.scss"

import cn from "classnames"
import SpinnerContainer from "../../components/buttons/SpinnerContainer"
import StickyButton from "../../components/buttons/StickyButton"
import TranslationsActions from "../../components/form/translations/TranslationsActions"
import TranslationsForm from "../../components/form/translations/TranslationsForm"
import { translationSelectors } from "../../store/reducers/translationSlice"
import {
    ensureTranslationUsageThunk,
    getTranslationLanguageConfigsThunk,
    getTranslationsThunk,
} from "../../store/thunks/translationsThunks"

const availableInEnvs: TEnv[] = ["Development", "Test", "Test2", "Betatest"]

interface ITranslationsPage {}

const TranslationsPage = ({}: ITranslationsPage) => {
    const dispatch = useReduxDispatch()

    const env = useSelector(sharedConfigurationSelectors.environment)
    const languageConfigs = useSelector(translationSelectors.languageConfigs)
    const files = useSelector(translationSelectors.files)
    const items = useSelector(translationSelectors.items)
    const currentLanguage = useSelector(translationSelectors.currentLanguage)
    const [showOverlay, setShowOverlay] = useState(false)

    useEffect(() => {
        if (!languageConfigs) {
            dispatch(getTranslationLanguageConfigsThunk())
            dispatch(ensureTranslationUsageThunk(false))
        } else {
            dispatch(getTranslationsThunk(languageConfigs.map((c) => c.language)))
        }
    }, [languageConfigs])

    if (!availableInEnvs.includes(env)) {
        return null
    }

    return (
        <PageWrapper fullWidth>
            <PageContainer id="translations-page">
                <PageTitle title="Translations Manager" />
                <SpinnerContainer showSpinner={!languageConfigs || !items} minHeight={100}>
                    {!!languageConfigs && !!items && <TranslationsForm languageConfigs={languageConfigs} items={items} />}
                </SpinnerContainer>
                <StickyButton
                    contentLeft={
                        <h4 className="translations-page__sticky-left">
                            {languageConfigs?.find((lc) => lc.language === currentLanguage)?.label ?? ""}
                        </h4>
                    }
                    onClick={() => {
                        setShowOverlay(true)
                    }}
                >
                    Actions
                </StickyButton>
                <div className={cn("translations-page__overlay", showOverlay && "translations-page__overlay--shown")}>
                    <div className="translations-page__overlay-bg" onClick={() => setShowOverlay(false)}></div>
                    <div className="translations-page__overlay-inner">
                        {languageConfigs && <TranslationsActions languageConfigs={languageConfigs} />}
                    </div>
                </div>
            </PageContainer>
        </PageWrapper>
    )
}

export default TranslationsPage
